import PixelAI from './PixelAI';

function App() {
  return <PixelAI />;
}

export default App;